import { LeftOutlined } from "@ant-design/icons";
import { Checkbox, Collapse } from "antd";
import React, { useEffect, useRef, useState } from 'react';
import { useBiology } from "../../../../../contexts/PlanOperationContext/Biology";
import { setTabBiology } from "../../../../../contexts/PlanOperationContext/TabBiology";
import { cloneObj, formatNumber } from "../../../../../util/varibles/global";
import { IPropsChildren } from "../../../../../util/varibles/interface";
import FishDisease from "../../_components/FishDisease";
import { getHarvests } from "../constants";
import stylesList from '../List/style.module.scss';
import stylesContainer from "../style.module.scss";
import styles from "./style.module.scss";

interface IProps extends IPropsChildren {
    item: any

    onDragStart(e: any, units: any): void

    onDragEnd(e: any): void
}

const GroupByUnit: React.FC<IProps> = (props) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef<HTMLDivElement>(null)
    const {
        site_name,
        unit_id,
        fish_amount,
        total_weight,
        checkAll,
        indeterminate,
        isActive,
        diseases
    } = props.item;
    const { onDragEnd } = props;
    const [isAllowedToCreate] = useBiology(state => state.isAllowedToCreate);
    const set = setTabBiology();

    useEffect(() => {
        const el = rootRef.current;
        if (el) {
            const element = el.getElementsByClassName('ant-collapse-header')[0];
            element.addEventListener('mousedown', handleMouseDown)
        }
    }, []);

    const handleMouseDown = (e: any) => {
        if (!e.target.closest('.ant-checkbox')) {
            setOpen(prev => !prev)
        }
    };

    const handleChange = (checked: boolean) => {
        const data = getHarvests(props.item.child);
        if (checked) {
            set(({ selected }) => ({ selected: { ...selected, ...data } }))
        } else {
            set(({ selected }) => {
                const value = cloneObj(selected);
                Object.keys(data).forEach(key => delete value[key]);
                return { selected: value }
            })
        }
    }

    const handleDragStart = (e: any) => props.onDragStart(e, props.item.child);

    return <Collapse
        className={stylesContainer.wrapper}
        activeKey={open ? [1] : []}
        expandIconPlacement={'end'}
        expandIcon={({ isActive }) => <LeftOutlined rotate={isActive ? -90 : 0} />}
        items={[{
            key: '1',
            ref: rootRef,
            label: <div className={styles['title-group']} data-is-active={isActive}>
                {isAllowedToCreate ? <Checkbox {...{
                    checked: checkAll,
                    indeterminate,
                    disabled: !isActive,
                    onChange: e => handleChange(e.target.checked)
                }} /> : <div />}
                <span>{[site_name, unit_id].join(', ')}</span>
                <span className='text-right'>{formatNumber(fish_amount)} fish(s)</span>
                <span className='text-right'>{formatNumber(Math.floor(total_weight / 1000) / 1000)}t</span>
                <div className={styles.diseases}>
                    <FishDisease data={diseases} />
                </div>
                {isAllowedToCreate && <div
                    className={stylesList['drag-view']}
                    draggable={isActive}
                    onDragStart={(e) => (isActive && isAllowedToCreate) ? handleDragStart(e) : null}
                    onDragEnd={onDragEnd}
                />}
            </div>,
            children: props.children
        }]}
    />
};

export default GroupByUnit;
